module.exports = __webpack_public_path__ + "_assets/img/profile-08.d045ee0f.svg";